import React from "react";
import { Route } from "react-router-dom";
import { GastosScreen } from "./Reportes/GastosScreen";
import { EstadoResultadosScreen } from "./Reportes/EstadoResultadosScreen";
import { LineaVenta } from "./Reportes/LineaVenta";
import { DashboardFinancieroScreen } from "./Dashboard/DashboardFinancieroScreen";
import { DashFinancieroMain } from "./Dashboard/DashFinancieroMain";
import { BalanceGeneralScreen } from "./Reportes/BalanceGeneral/BalanceGeneralScreen";
import { MargenScreen } from "./Reportes/MargenScreen";
import { MargenesBrutosScreen } from "./Reportes/MargenesBrutosScreen";
import AntiguedadInventarioScreen from "./Reportes/AntiguedadInventario/AntiguedadInventarioScreen";
import { CostoFinanciamientoScreen } from "./Reportes/CostoFinanciamiento/CostoFinanciamientoScreen";
import { ResultadosSucursalScreen } from "./Reportes/ResultadosSucursal/ResultadosSucursalScreen";
import { NivelInventarioScreen } from "./Reportes/NivelInventario/NivelInventarioScreen";
import { ProyeccionesVentasScreen, ProyeccionVentasScreen } from "./Reportes/ProyeccionesVentas/ProyeccionesVentasScreen";
import { ProyeccionGastoScreen } from "./Reportes/Proyecciones Gastos/ProyeccionesGastosScreen";
import { DashFinancieroContext } from "./Dashboard/DashFinancieroMain";
import { InventarioRotacionMainScreen } from "./Reportes/Inventario Rotacion/InventarioRotacionMainScreen";
import { RotacionCXCMainScreen } from "./Reportes/Rotacion CXC/RotacionCXCMainScreen";
import { GuiaCXCMainScreen } from "./Reportes/Rotacion CXC/GuiaCXCMainScreen";
import { RotacionCXCSucursalScreen } from "./Reportes/Rotacion CXC/RotacionCXCSucursalScreen";
import { DetalleCXCMainScreen } from "./Reportes/Rotacion CXC/DetalleCXCMainScreen";

export const FinanzasMainScreen = () => {
  return (
    <div className="main-container">
      <Route
        path="/Finanzas/Main"
        component={() => <DashFinancieroMain />}
      />
      <Route
        path="/Finanzas/Gastos"
        component={() => <GastosScreen />}
      />
      <Route
        path="/Finanzas/EstadodeResultados"
        component={() => <EstadoResultadosScreen />}
      />
      <Route
        path="/Finanzas/LineasVenta"
        component={() => <LineaVenta />}
      />
      <Route
        path="/Finanzas/BalanceGeneral"
        component={() => <BalanceGeneralScreen />}
      />
      <Route
        path="/Finanzas/MargenesDetalle"
        component={() => <MargenesBrutosScreen />}
      />
      <Route
        path="/Finanzas/AntiguedadIntentario"
        component={() => <AntiguedadInventarioScreen />}
      />
      <Route
        path="/Finanzas/CostoFinanciamiento"
        component={() => <CostoFinanciamientoScreen />}
      />
      <Route
        path="/Finanzas/ResultadosSucursal"
        component={() => <ResultadosSucursalScreen />}
      />
      <Route
        path="/Finanzas/NivelInventario"
        component={() => <NivelInventarioScreen />}
      />
      <Route
        path="/Finanzas/ProyeccionesVentas"
        component={() => <ProyeccionesVentasScreen />}
      />
      <Route
        path="/Finanzas/ProyeccionesGastos"
        component={() => <ProyeccionGastoScreen />}
      />
      <Route
        path="/Finanzas/RotacionInventario"
        component={() => <InventarioRotacionMainScreen />}
      />
      <Route
        path="/Finanzas/RotacionCXC"
        component={() => <RotacionCXCMainScreen />}
      />
      <Route
        path="/Finanzas/GuiaCXC"
        component={() => <GuiaCXCMainScreen />}
      />
      <Route
        path="/Finanzas/RotacionCXCSucursal"
        component={() => <RotacionCXCSucursalScreen />}
      />
      <Route
        path="/Finanzas/DetalleCXC"
        component={() => <DetalleCXCMainScreen />}
      />
      <Route
        path="/Finanzas/RotacionCXCOptima"
        component={() => <RotacionCXCMainScreen />}
      />
    </div>
  );
};
